import { Container, IconButton } from '@melio/penny';
import { VFC } from 'react';

export const Header: VFC<{
  onClose: VoidFunction;
  onBack?: VoidFunction;
  isDisabled?: boolean;
}> = ({ isDisabled, onClose, onBack }) => (
  <Container
    justifyContent={onBack ? 'space-between' : 'flex-end'}
    paddingX="m"
    paddingY="s"
    backgroundColor="light"
    data-component={Header.displayName}
  >
    {onBack && (
      <IconButton
        aria-label="back-button"
        variant="naked"
        icon="chevron-left"
        onClick={onBack}
        isDisabled={isDisabled}
        data-testid="layout-back-button"
      />
    )}
    <IconButton
      aria-label="close-button"
      variant="naked"
      icon="close"
      onClick={onClose}
      isDisabled={isDisabled}
      data-testid="layout-close-button"
    />
  </Container>
);

Header.displayName = 'Header';
